import { render, staticRenderFns } from "./ActionInfo.vue?vue&type=template&id=f32f230c&scoped=true&"
import script from "./ActionInfo.vue?vue&type=script&lang=js&"
export * from "./ActionInfo.vue?vue&type=script&lang=js&"
import style0 from "./ActionInfo.vue?vue&type=style&index=0&id=f32f230c&lang=css&scoped=true&"
import style1 from "./ActionInfo.vue?vue&type=style&index=1&id=f32f230c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32f230c",
  null
  
)

export default component.exports